import { _ as __assign } from './_tslib-ff3a08af.js';
import { jsx } from 'react/jsx-runtime';
import { debounce } from 'lodash';
import AsyncSelect from 'react-select/async';
import { D as DropdownIndicator } from './DropdownIndicator-00a8b4ed.js';
import { C as ClearIndicator } from './ClearIndicator-e1d121b8.js';
import { a as customAsyncSelectStyles, c as customAsyncSelectStylesNew } from './AsyncCustomSelect.styles-b52feb81.js';

var AsyncCustomSelect = function (props) {
    var _a;
    var onChange = props.onChange,
        onLoadData = props.onLoadData,
        value = props.value,
        isReadonly = props.isReadonly,
        placeholder = props.placeholder,
        error = props.error,
        dataTestId = props.dataTestId;
    var isMultiSelect = Array.isArray(value);
    var loadOptions = debounce(function (inputValue, callback) {
        onLoadData(inputValue).then(function (data) {
            callback(data);
        });
    }, 500);
    var selectedOption = value;
    var isSelectEmpty = function (value) {
        if (isMultiSelect) {
            return value.length > 0;
        }
        return value === null || value === void 0 ? void 0 : value.value;
    };
    return jsx("div", { "data-testid": dataTestId, children: jsx(AsyncSelect, { placeholder: placeholder, menuPortalTarget: document.body, defaultOptions: true, components: {
                DropdownIndicator: DropdownIndicator,
                IndicatorSeparator: function () {
                    return null;
                },
                ClearIndicator: ClearIndicator
            }, loadOptions: loadOptions, onChange: function (e, action) {
                if (action.action === 'clear') {
                    var emptyOption = isMultiSelect ? [] : { label: '', value: undefined };
                    onChange(emptyOption);
                } else {
                    var option = isMultiSelect ? e : e;
                    onChange(option);
                }
            }, styles: __assign(__assign(__assign({}, (_a = props.customStyles) !== null && _a !== void 0 ? _a : customAsyncSelectStyles), props.newEditableLook ? customAsyncSelectStylesNew(error) : {}), { menuPortal: function (base) {
                    return __assign(__assign({}, base), { zIndex: 9999 });
                } }), value: selectedOption, isDisabled: isReadonly, onBlur: props.onBlur, getOptionLabel: function (option) {
                return option.label;
            }, getOptionValue: function (option) {
                return option.value;
            }, isClearable: props.clearable && isSelectEmpty(value), isMulti: isMultiSelect }) });
};

export { AsyncCustomSelect as A };
